import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardTitle, CardHeader, CardFooter, ButtonToolbar, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, Alert} from 'reactstrap';
import { ajaxWrapperGet,ajaxWrapperGetQuery } from '../../../utils/deviceAPI';
import {CSVLink, CSVDownload} from 'react-csv';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import moment from 'moment'
import DeviceOffline from '../DeviceMessages/DeviceOffline';
import Error from '../DeviceMessages/Error';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import {isDeviceOnline} from "../../../utils/isDeviceOnline";
import { Bar, Line } from 'react-chartjs-2';
import { DateRangePicker, isInclusivelyAfterDay, isSame } from 'react-dates';
const brandPrimary = getStyle('--primary');
const brandSuccess = getStyle('--success');
const brandInfo = getStyle('--info');
const brandWarning = getStyle('--warning');
const brandDanger = getStyle('--danger');






class Graph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            radioSelected: "1H"
        };
    }
    componentDidMount() {
        this.setState({
            loading: false
        });
        this.onRadioBtnClick = this.onRadioBtnClick.bind(this);

    }

    onRadioBtnClick(radioSelected,startDate = null,endDate = null) {
        this.props.selectedDate(radioSelected,startDate,endDate);
        this.setState({
            radioSelected: radioSelected,
        });
    }

    componentWillUnmount(){

    }

    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        const tomorrow = moment().add(1, 'days');
        const today = moment();
        return (
            <div className="animated fadeIn">

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="12" md="5">
                                        <CardTitle className="mb-0">{this.props.chartTitle}</CardTitle>
                                        <div className="small text-muted">displaying data from <span className="text-info">{moment.unix(this.props.startDate).format("MM/DD/YYYY, h:mm a")}</span> to <span className="text-info">{moment.unix(this.props.endDate).format("MM/DD/YYYY, h:mm a")}</span></div>
                                        
                                    </Col>
                                </Row>
                                <div className="chart-wrapper" style={{ height: 350 + 'px', marginTop: 40 + 'px' }}>
                                    <Line data={this.props.mainChart} options={this.props.mainChartOpts} height={350} />
                                </div>
                                <Row>
                                    <Col sm="12">
                                        <hr className="mb-4"/>
                                    </Col>
                                </Row>
                                <Row className="text-left pt-3">
                                    <Col sm="12" md="5">
                                        <DateRangePicker
                                            startDate={this.state.startDate}
                                            startDateId="startDate"
                                            endDate={this.state.endDate}
                                            endDateId="endDate"
                                            onDatesChange={({startDate, endDate}) => this.setState({startDate, endDate})}
                                            focusedInput={this.state.focusedInput}
                                            onFocusChange={focusedInput => this.setState({focusedInput})}
                                            orientation={this.state.orientation}
                                            openDirection={this.state.openDirection}
                                            block={false}
                                            small={true}
                                            withPortal={true}
                                            enableOutsideDays={true}
                                            isOutsideRange={day => isInclusivelyAfterDay(day, tomorrow)}
                                            isDayHighlighted={day => day.isSame( today, 'd' )}

                                        />
                                        <Button color={this.state.radioSelected === "Custom" ? "primary" : "outline-secondary"} onClick={() => this.state.radioSelected === "Custom"? null : this.onRadioBtnClick("Custom",this.state.startDate,this.state.endDate)} disabled={this.state.startDate === undefined && this.state.endDate === undefined} active={this.state.radioSelected === "Custom"}>Custom</Button>

                                    </Col>
                                    <Col sm="12" md="7">
                                        <ButtonToolbar className="float-right" aria-label="Toolbar with button groups">
                                            <ButtonGroup className="mr-3" aria-label="First group">
                                                <Button color={this.state.radioSelected === "Day" ? "primary" : "outline-secondary"} onClick={() => this.state.radioSelected === "Day"? null : this.onRadioBtnClick("Day")} active={this.state.radioSelected === "Day"}>Day</Button>
                                                <Button color={this.state.radioSelected === "12H" ? "primary" : "outline-secondary"} onClick={() => this.state.radioSelected === "12H"? null : this.onRadioBtnClick("12H")} active={this.state.radioSelected === "12H"}>12 H</Button>
                                                <Button color={this.state.radioSelected === "6H" ? "primary" : "outline-secondary"} onClick={() => this.state.radioSelected === "6H"? null : this.onRadioBtnClick("6H")} active={this.state.radioSelected === "6H"}>6 H</Button>
                                                <Button color={this.state.radioSelected === "3H" ? "primary" : "outline-secondary"} onClick={() => this.state.radioSelected === "3H"? null : this.onRadioBtnClick("3H")} active={this.state.radioSelected === "3H"}>3 H</Button>
                                                <Button color={this.state.radioSelected === "1H" ? "primary" : "outline-secondary"} onClick={() => this.state.radioSelected === "1H"? null : this.onRadioBtnClick("1H")} active={this.state.radioSelected === "1H"}>1 H</Button>
                                            </ButtonGroup>
                                        </ButtonToolbar>
                                    </Col>
                                </Row>
                            </CardBody>

                        </Card>

            </div>
        )
    }
}

export default Graph;



// WEBPACK FOOTER //
// ./src/views/site/Historical/Graph.js